import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { services } from '../data/companyData';
import './ServicesPage.css';

export default function ServicesPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const serviceParam = searchParams.get('service');
  
  // Find if there's a valid service in query parameters
  const initialActive = services.some(s => s.id === serviceParam) ? serviceParam : services[0].id;
  const [active, setActive] = useState(initialActive);

  // Update active service and scroll if search parameter changes
  useEffect(() => {
    if (serviceParam && services.some(s => s.id === serviceParam)) {
      setActive(serviceParam);
      
      const explorer = document.querySelector('.svc-explorer');
      if (explorer) {
        setTimeout(() => {
          explorer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [serviceParam]);

  const activeService = services.find(s => s.id === active);

  return (
    <main className="services-page">

      <section className="page-header">
        <div className="container page-header__inner">
          <span className="tag">What We Offer</span>
          <h1 className="page-header__title">
            Full-Scope<br />
            <span style={{ color: 'var(--gold)' }}>Maintenance Services</span>
          </h1>
          <p className="page-header__sub">
            Comprehensive operations & maintenance across MEP, HVAC, civil, fire safety, and integrated facility management.
          </p>
        </div>
      </section>

      {/* Interactive services */}
      <section className="section">
        <div className="container svc-explorer">
          <div className="svc-explorer__tabs">
            {services.map(s => (
              <button
                key={s.id}
                className={`svc-tab ${active === s.id ? 'svc-tab--active' : ''}`}
                onClick={() => {
                  setActive(s.id);
                  setSearchParams({ service: s.id });
                }}
              >
                <span className="svc-tab__icon">{s.icon}</span>
                <span className="svc-tab__label">{s.title}</span>
              </button>
            ))}
          </div>
          <div className="svc-explorer__panel">
            {activeService && (
              <>
                <div className="svc-panel__header">
                  <span className="svc-panel__icon">{activeService.icon}</span>
                  <div>
                    <h2 className="svc-panel__title">{activeService.title}</h2>
                    <p className="svc-panel__desc">{activeService.description}</p>
                  </div>
                </div>
                <div className="svc-panel__divider" />
                <div className="svc-panel__items">
                  {activeService.items.map(item => (
                    <div key={item} className="svc-panel__item">
                      <span className="svc-panel__bullet">→</span>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                <div className="svc-panel__cta">
                  <Link to="/contact" className="btn btn-primary">
                    Get a Quote
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* All services grid */}
      <section className="section section--cream">
        <div className="container">
          <div style={{ marginBottom: 48 }}>
            <span className="tag">Full Overview</span>
            <h2 className="section-title">All Services</h2>
          </div>
          <div className="all-svc-grid">
            {services.map(s => (
              <div 
                key={s.id} 
                className="all-svc-card"
              >
                <div className="all-svc-card__icon">{s.icon}</div>
                <h3 className="all-svc-card__title">{s.title}</h3>
                <p className="all-svc-card__count">{s.items.length} service areas</p>
                <ul className="all-svc-card__list">
                  {s.items.map(item => (
                    <li key={item}><span className="service-card__bullet" />{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Maintenance types */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <span className="tag">Maintenance Programs</span>
            <h2 className="section-title">Our Maintenance Framework</h2>
          </div>
          <div className="maint-grid">
            {[
              { type: 'Daily', color: '#b8965a', items: ['Routine building inspections', 'Lighting checks', 'Plumbing & sanitary checks', 'Common area maintenance'] },
              { type: 'Preventive', color: '#2c2c2c', items: ['Scheduled MEP servicing', 'HVAC filter changes', 'Generator load testing', 'Fire system inspections'] },
              { type: 'Corrective', color: '#5a5a5a', items: ['Fault repair & replacement', 'Reactive call-outs', 'Parts replacement', 'System restoration'] },
              { type: 'Emergency', color: '#8c6d3f', items: ['24/7 power outage response', 'Flood & leak response', 'Critical system recovery', 'Emergency call-outs'] },
            ].map(m => (
              <div key={m.type} className="maint-card" style={{ '--maint-color': m.color }}>
                <div className="maint-card__stripe" />
                <div className="maint-card__type">{m.type}<br />Maintenance</div>
                <ul className="maint-card__list">
                  {m.items.map(item => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
}
